var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"font-weight-bold",attrs:{"small":"","color":"white"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":"","color":"warning"}},[_vm._v("mdi-alert-circle")]),_vm._v(_vm._s(_vm.text))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }